<template>
  <v-container fluid>
    <SidebarNavigation />
    <v-card>
      <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab v-for="item in tabItems" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>
    <v-card>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row class="pt-3 pr-1 pl-1">
            <v-col cols="2.5">
              <v-autocomplete
                :items="divisionsOptions"
                @change="updateQuery('divisionId', $event)"
                item-text="mst_division_name"
                item-value="mst_division_id"
                label="Department"
                dense
                outlined
                v-model="selectedDivisionId"
              ></v-autocomplete>
            </v-col>
            <v-col cols="2.5">
              <v-autocomplete
                item-text="mst_position_name"
                item-value="mst_position_id"
                :items="positionOptions"
                v-model="selectedPositionId"
                @change="updateQuery('positionId', $event)"
                label="Posisi "
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="2.5">
              <v-autocomplete
                item-text="mst_site_name"
                item-value="mst_site_id"
                :items="siteOptions"
                v-model="selectedSiteId"
                @change="updateQuery('siteId', $event)"
                label="Lokasi Kerja"
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="2.5">
              <v-text-field
                v-model="pagination.search"
                label="Search"
                append-icon="mdi-magnify"
                dense
                hide-details
                class="search-input"
                style="max-width: 250px"
                outlined
                @input="debouncedSearch"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-data-table
                mobile-breakpoint="0"
                fixed-header
                dense
                class="elevation-5"
                :headers="tableHeaders"
                :items="employeeList"
                :items-per-page.sync="pagination.itemsPerPage"
                :page.sync="pagination.page"
                :sort-by="pagination.sortBy"
                :sort-desc="pagination.sortDesc"
                :server-items-length="totalEmployee"
                item-key="id"
                @update:page="updateQuery('page', $event)"
                @update:items-per-page="updateQuery('itemsPerPage', $event)"
                @update:sort-by="updateQuery('sortBy', $event)"
                @update:sort-desc="updateQuery('sortDesc', $event)"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>{{ item.mst_employee_name }}</td>
                      <td>{{ item.mst_employee_nik }}</td>
                      <td>{{ item.mst_employee_email }}</td>
                      <td>{{ item.mst_division_name }}</td>
                      <td>{{ item.mst_position_name }}</td>
                      <td>{{ item.mst_site_name }}</td>
                      <!-- <td>{{ item.group_name }}</td> -->
                      <!-- <td>{{ item.point }}</td> -->
                      <td>
                        <v-btn icon @click="openDialogUpdate(item)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- update -->
    <v-dialog v-model="isDialogOpenEdit" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Ubah Employee</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidUpdate">
            <v-text-field
              :rules="[(v) => !!v || 'Nama tidak boleh kosong !']"
              v-model="name"
              label="Nama"
            ></v-text-field>
            <v-text-field
              :rules="[(v) => !!v || 'Nik tidak boleh kosong !']"
              v-model="nik"
              label="NIK"
            ></v-text-field>
            <v-text-field
              :rules="[(v) => !!v || 'Email tidak boleh kosong !']"
              v-model="email"
              label="Email"
            ></v-text-field>

            <v-autocomplete
              :items="divisionsOptions"
              item-text="mst_division_name"
              item-value="mst_division_id"
              label="Department"
              dense
              outlined
              :rules="[
                (v) => !!v || 'Divisi tidak boleh kosong !',
                (v) => v !== 0 || 'Divisi tidak boleh 0 !',
              ]"
              v-model="selectedDivisionId"
            ></v-autocomplete>

            <v-autocomplete
              item-text="mst_position_name"
              item-value="mst_position_id"
              :items="positionOptions"
              v-model="selectedPositionId"
              label="Jabatan"
              dense
              outlined
              :rules="[
                (v) => !!v || 'Posisi tidak boleh kosong !',
                (v) => v !== 0 || 'Posisi tidak boleh 0 !',
              ]"
            ></v-autocomplete>

            <v-autocomplete
              :rules="[
                (v) => !!v || 'Site tidak boleh kosong !',
                (v) => v !== 0 || 'Site tidak boleh 0 !',
              ]"
              item-text="mst_site_name"
              item-value="mst_site_id"
              :items="siteOptions"
              v-model="selectedSiteId"
              label="Lokasi Kerja"
              dense
              outlined
            ></v-autocomplete>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenEdit = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidUpdate"
            @click="submitUpdate"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      tabItems: ["Employee"],
      isLoading: false,
      search: "",
      tab: 1,
      tableHeaders: [
        { text: "Name", align: "center", value: "name" },
        { text: "Nik", align: "center", value: "nik" },
        { text: "Email", align: "center", value: "email" },
        { text: "Department", align: "center", value: "divition" },
        { text: "Jabatan", align: "center", value: "posisi" },
        { text: "Lokasi Kerja", align: "center", value: "site" },
        // {text: "group",align: "center",value: "group",},
        // { text: "Point", align: "center", value: "point" },
        { text: "Aksi", align: "center" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        search: "",
      },
      totalEmployee: null,
      employeeList: [],
      employee: { mst_employee_name: "" },
      isDialogOpenEdit: false,
      isDialogOpenDelete: false,
      isFormValidUpdate: false,
      mst_employee_name: null,
      divisionsOptions: null,
      positionOptions: null,
      siteOptions: null,
      selectedDivisionId: null,
      selectedPositionId: null,
      selectedSiteId: null,
      nik: null,
      email: null,
      name: null,
      point: 0,
    };
  },
  methods: {
    fetchDivisions() {
      this.isDivisionsLoading = true;
      api
        .get("/divisions")
        .then(({ data }) => {
          this.divisionsOptions = data.data.data;
          this.divisionsOptions.unshift({
            mst_division_id: "all",
            mst_division_name: "all",
          });
        })
        .catch((error) => {
          console.error("Error fetching division:", error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isDivisionsLoading = false;
          store.dispatch("hideLoading");
        });
    },

    fetchPosition() {
      api
        .get(`/positions?divisionId=${this.selectedDivisionId}`)
        .then(({ data }) => {
          this.positionOptions = data.data.data;
          this.positionOptions.unshift({
            mst_position_id: "all",
            mst_position_name: "all",
          });
        })
        .catch((error) => {
          console.error("Error fetching position:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    fetchSites() {
      api
        .get("/sites?corporateId=2")
        .then(({ data }) => {
          this.siteOptions = data.data.data;
          this.siteOptions.unshift({
            mst_site_id: "all",
            mst_site_name: "all",
          });
        })
        .catch((error) => {
          console.error("Error fetching sites:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    fetchEmployees() {
      store.dispatch("showLoading");
      const query = this.$route.query;
      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "name",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
        divisionId: query.divisionId || this.divisionId || "all",
        positionId: query.positionId || this.positionId || "all",
        siteId: query.siteId || this.siteId || "all",
        point: query.point || this.pagination.point || true,
      };

      api
        .get("/employees", { params })
        .then(({ data }) => {
          this.employeeList = data.data.data;
          this.totalEmployee = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching employees:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    openDialogUpdate(params = null) {
      this.employee = params;
      this.mst_employee_name = params.mst_employee_name;
      this.selectedDivisionId = params.mst_division_id;
      this.selectedPositionId = params.mst_position_id;
      this.selectedSiteId = params.mst_site_id;
      this.selectedEmployeeId = params.mst_employee_id;
      this.nik = params.mst_employee_nik;
      this.email = params.mst_employee_email;
      this.name = params.mst_employee_name;
      this.isDialogOpenEdit = true;
    },
    openDialogDelete(params) {
      this.employee = params;
      this.isDialogOpenDelete = true;
    },

    submitUpdate() {
      store.dispatch("showLoading");
      const payload = {
        mst_employee_id: this.employee.mst_employee_id,
        mst_employee_name: this.name,
        mst_employee_nik: this.nik,
        mst_employee_email: this.email,
        mst_division_id: this.selectedDivisionId,
        mst_position_id: this.selectedPositionId,
        mst_site_id: this.selectedSiteId,
      };
      api
        .post("/employees/update", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchEmployees();
          this.isDialogOpenEdit = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save employee!";
          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      // console.log(query);
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.selectedDivisionId = parseInt(query.divisionId) || 0;
      this.selectedPositionId = parseInt(query.positionId) || 0;
      this.selectedSiteId = parseInt(query.siteId) || 0;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
  },
  mounted() {
    store.commit("setTitle", "Employees");
    this.fetchDivisions();
    this.fetchSites();
    this.updatePagination(this.$route.query);
  },
  watch: {
    pagination: {
      handler: "fetchEmployees",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
    selectedDivisionId() {
      this.fetchPosition();
      this.fetchEmployees();
    },
    selectedPositionId() {
      this.fetchEmployees();
    },
    selectedSiteId() {
      this.fetchEmployees();
    },
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(8),
td:nth-child(9) {
  text-align: center;
}
</style>
